import React from 'react'
import '../styles/Loader.css'
function Loader() {
  return (<>
    <div className='load'></div>
    </>
  )
}

export default Loader